var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.65 31.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #828282;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.05,0h-14.46C3.86,0,0,3.86,0,8.6v14.46c0,4.74,3.86,8.6,8.6,8.6h14.46c4.74,0,8.6-3.86,8.6-8.6v-14.46c0-4.74-3.86-8.6-8.6-8.6ZM30.7,23.05c0,4.22-3.43,7.65-7.65,7.65h-14.46c-4.22,0-7.65-3.43-7.65-7.65v-14.46C.95,4.38,4.38.95,8.6.95h14.46c4.22,0,7.65,3.43,7.65,7.65v14.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.31,20.36c0,.1-.04.18-.1.25-.06.06-.15.1-.25.1h-2.39v2.39c0,.19-.16.35-.35.35-.1,0-.18-.04-.25-.1-.06-.06-.1-.15-.1-.25v-2.39h-2.39c-.2,0-.35-.16-.35-.35,0-.1.04-.19.1-.25.06-.06.15-.1.25-.1h2.39v-2.39c0-.19.16-.35.35-.35.1,0,.18.04.25.1.06.06.1.15.1.25v2.39h2.39c.2,0,.35.16.35.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.26,16.31l-2.96-2.11c.37-.67.59-1.44.59-2.27v-2.4c0-2.15-1.74-3.89-3.89-3.89h-1.59c-2.15,0-3.89,1.74-3.89,3.89v2.4c0,.82.21,1.59.59,2.27l-2.96,2.11c-1.16.83-1.86,2.18-1.86,3.61v2.12c0,1.15.69,2.18,1.75,2.63,2.27.95,4.7,1.43,7.15,1.43s4.89-.47,7.18-1.43c1.07-.44,1.76-1.48,1.76-2.63v-2.11c0-1.43-.69-2.78-1.86-3.61ZM12.89,9.53c0-1.39,1.13-2.52,2.52-2.52h1.59c1.39,0,2.52,1.13,2.52,2.52v2.4c0,1.83-1.49,3.31-3.31,3.31s-3.31-1.49-3.31-3.31v-2.4ZM23.75,22.03c0,.6-.36,1.13-.97,1.39-4.2,1.74-9.02,1.74-13.22-.02-.55-.23-.91-.76-.91-1.36v-2.12c0-.99.48-1.92,1.28-2.49l3-2.14c.84.82,2,1.33,3.27,1.33s2.42-.51,3.27-1.33l3,2.14c.8.57,1.28,1.51,1.28,2.49v2.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteGrey);
export default __webpack_public_path__ + "static/media/invite-grey.90cbd3bd3310584c0a30015a077bdbaf.svg";
export { ForwardRef as ReactComponent };